var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgSortArrowDown = function SvgSortArrowDown(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 3.75C13.25 3.05964 12.6904 2.5 12 2.5C11.3096 2.5 10.75 3.05964 10.75 3.75V18.2322L4.13388 11.6161C3.64573 11.128 2.85427 11.128 2.36612 11.6161C1.87796 12.1043 1.87796 12.8957 2.36612 13.3839L11.1143 22.1321C11.1195 22.1372 11.1246 22.1424 11.1299 22.1474C11.2455 22.2596 11.3775 22.345 11.518 22.4037C11.6663 22.4657 11.8292 22.5 12 22.5C12.341 22.5 12.6502 22.3634 12.8757 22.142C12.8788 22.1389 12.8819 22.1359 12.885 22.1328L21.6339 13.3839C22.122 12.8957 22.122 12.1043 21.6339 11.6161C21.1457 11.128 20.3543 11.128 19.8661 11.6161L13.25 18.2322V3.75Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgSortArrowDown);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-icons/icons/SortArrowDown.8e479b275a92bdbc157bdcff76215aab.svg";